(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["browse-more-slideshow"] && !Shopify.designMode) return;
  try {
    
  function initProductSliders() {
    const sliderWrappers = document.querySelectorAll('.browse-more__slider-wrapper');
    
    sliderWrappers.forEach(wrapper => {
      if (wrapper.dataset.sliderInitialized) return;
      wrapper.dataset.sliderInitialized = 'true';

      const container = wrapper.querySelector('.slider__container');
      const track = wrapper.querySelector('.slider__track');
      const prevBtn = wrapper.querySelector('.slider__btn-prev');
      const nextBtn = wrapper.querySelector('.slider__btn-next');

      if (!container || !track) return;

      // Client-side Shuffle (Randomizer)
      if (track.getAttribute('data-randomize') === 'true') {
        const slides = Array.from(track.children);
        if (slides.length > 1) {
          for (let i = slides.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            track.appendChild(slides[j]);
          }
        }
      }

      if (prevBtn && nextBtn) {
        // Desktop / Click navigation
        const scrollAmount = () => {
          const firstSlide = container.querySelector('.slider__slide');
          if (firstSlide) {
            return firstSlide.offsetWidth + 24; // Slide width + gap
          }
          return container.offsetWidth * 0.8;
        };

        prevBtn.addEventListener('click', () => {
          container.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
          container.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });

        // Hide/Show navigation buttons based on scroll boundaries
        const updateArrows = () => {
          const isScrollStart = container.scrollLeft <= 2;
          const isScrollEnd = container.scrollLeft + container.offsetWidth >= container.scrollWidth - 2;
          
          prevBtn.style.opacity = isScrollStart ? '0.4' : '1';
          prevBtn.style.pointerEvents = isScrollStart ? 'none' : 'auto';
          
          nextBtn.style.opacity = isScrollEnd ? '0.4' : '1';
          nextBtn.style.pointerEvents = isScrollEnd ? 'none' : 'auto';
        };

        container.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        updateArrows();
        
        // Timeout check to ensure rendering dimensions are captured
        setTimeout(updateArrows, 100);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initProductSliders);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initProductSliders);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-deal"] && !Shopify.designMode) return;
  try {
    
  function initCountdownTimers() {
    const timers = document.querySelectorAll('[data-countdown-end]');
    timers.forEach(function(timer) {
      const endTimeAttr = timer.getAttribute('data-countdown-end');
      if (!endTimeAttr) return;
      const endTime = new Date(endTimeAttr).getTime();
      if (isNaN(endTime)) return;
      
      const daysEl = timer.querySelector('.countdown__days');
      const hoursEl = timer.querySelector('.countdown__hours');
      const minutesEl = timer.querySelector('.countdown__minutes');
      const secondsEl = timer.querySelector('.countdown__seconds');
      const msgEl = timer.querySelector('.countdown__expired-message');
      const clockEl = timer.querySelector('.countdown__clock');
      
      function updateClock() {
        const now = new Date().getTime();
        const distance = endTime - now;
        
        if (distance < 0) {
          clearInterval(interval);
          if (clockEl) clockEl.style.display = 'none';
          if (msgEl) msgEl.style.display = 'block';
          return;
        }
        
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      }
      
      updateClock();
      const interval = setInterval(updateClock, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', initCountdownTimers);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCountdownTimers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCustomHeader() {
      var wrapper = document.querySelector('.custom-header-wrapper');
      if (!wrapper) return;

      var hamburger = wrapper.querySelector('.custom-header__hamburger');
      var mobileMenu = document.querySelector('.custom-mobile-menu');
      var closeBtn = mobileMenu ? mobileMenu.querySelector('.custom-mobile-menu__close-btn') : null;
      var overlay = mobileMenu ? mobileMenu.querySelector('.custom-mobile-menu__overlay') : null;

      function getMobileLinks() {
        return mobileMenu ? mobileMenu.querySelectorAll('.custom-mobile-menu__link, .mobile-submenu__link, .custom-mobile-menu__account, .custom-mobile-menu__search') : [];
      }

      function openMenu() {
        if (!mobileMenu || !hamburger) return;
        mobileMenu.setAttribute('aria-hidden', 'false');
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        getMobileLinks().forEach(function(el) { el.removeAttribute('tabindex'); });
      }

      function closeMenu() {
        if (!mobileMenu || !hamburger) return;
        mobileMenu.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        getMobileLinks().forEach(function(el) { el.setAttribute('tabindex', '-1'); });
      }

      if (hamburger) hamburger.addEventListener('click', openMenu);
      if (closeBtn) closeBtn.addEventListener('click', closeMenu);
      if (overlay) overlay.addEventListener('click', closeMenu);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeMenu();
      });

      /* Sticky scroll shadow */
      if (wrapper.classList.contains('custom-header--sticky')) {
        var onScroll = function() {
          wrapper.classList.toggle('is-scrolled', window.scrollY > 10);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      /* Collections toggle — desktop: first click opens dropdown, second click navigates */
      wrapper.querySelectorAll('.collections-nav-toggle').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          var item = btn.closest('.collections-nav-item');
          var dropdown = item ? item.querySelector('.collections-nav-dropdown') : null;
          if (!dropdown) return;

          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            window.location.href = btn.dataset.href;
            return;
          }

          e.preventDefault();
          btn.setAttribute('aria-expanded', 'true');
          dropdown.classList.add('is-open');
          document.querySelectorAll('.nav-details[open]').forEach(function(d) { d.removeAttribute('open'); });
        });
      });

      /* Collections toggle — mobile: first click opens submenu, second click navigates */
      if (mobileMenu) {
        mobileMenu.querySelectorAll('.mobile-collections-toggle').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            var item = btn.closest('.custom-mobile-menu__item');
            var submenu = item ? item.querySelector('.mobile-submenu') : null;
            if (!submenu) return;

            var isOpen = btn.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              window.location.href = btn.dataset.href;
              return;
            }

            e.preventDefault();
            btn.setAttribute('aria-expanded', 'true');
            submenu.removeAttribute('hidden');
            submenu.querySelectorAll('a').forEach(function(a) { a.removeAttribute('tabindex'); });
          });
        });
      }

      /* Close desktop dropdown when clicking outside */
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.has-dropdown') && !e.target.closest('.collections-nav-item')) {
          document.querySelectorAll('.nav-details[open]').forEach(function(d) { d.removeAttribute('open'); });
          document.querySelectorAll('.collections-nav-toggle[aria-expanded="true"]').forEach(function(btn) {
            btn.setAttribute('aria-expanded', 'false');
            var item = btn.closest('.collections-nav-item');
            var dd = item ? item.querySelector('.collections-nav-dropdown') : null;
            if (dd) dd.classList.remove('is-open');
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCustomHeader);
    } else {
      initCustomHeader();
    }
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', initCustomHeader);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-deal-hero"] && !Shopify.designMode) return;
  try {
    
  function initFlashDealHero() {
    const productsDataEl = document.getElementById('flash-deal-products-data');
    if (!productsDataEl) return;
    
    let products = [];
    try {
      products = JSON.parse(productsDataEl.textContent);
    } catch(e) {
      console.error("Failed to parse flash deal products data", e);
      return;
    }

    const heroContainer = document.querySelector('.flash-deal-hero');
    if (!heroContainer) return;

    if (products.length === 0) {
      const titleLink = heroContainer.querySelector('.flash-deal-hero__product-link');
      if (titleLink) titleLink.textContent = "Flash Deal collection is empty or out of stock.";
      return;
    }

    const timerEl = heroContainer.querySelector('.flash-deal-hero__timer');
    if (!timerEl) return;

    const intervalHours = parseInt(timerEl.getAttribute('data-interval-hours')) || 4;
    const intervalMs = intervalHours * 60 * 60 * 1000;

    const hoursEl = timerEl.querySelector('.timer__hours');
    const minutesEl = timerEl.querySelector('.timer__minutes');
    const secondsEl = timerEl.querySelector('.timer__seconds');

    const productTitleEl = heroContainer.querySelector('.flash-deal-hero__product-title');
    const productLinkEl = heroContainer.querySelector('.flash-deal-hero__product-link');
    const imgLinkEl = heroContainer.querySelector('.flash-deal-hero__img-link');
    const productImageEl = heroContainer.querySelector('.flash-deal-hero__image');
    const comparePriceEl = heroContainer.querySelector('.price__compare-price');
    const currentPriceEl = heroContainer.querySelector('.price__current-price');
    const discountBadgeEl = heroContainer.querySelector('.price__discount-badge');
    const variantInputEl = heroContainer.querySelector('.flash-deal-variant-id');
    const stockFillEl = heroContainer.querySelector('.stock-warning__fill');
    const stockTextEl = heroContainer.querySelector('.stock-warning__text');

    // Fetch dynamic settings from stylesheet custom properties or assume defaults
    const discountPercentage = 50; // default 50% discount
    const discountMultiplier = 0.5;

    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }

    let activeProductIndex = -1;

    function updateActiveProduct() {
      const now = Date.now();
      
      // Determine index based on floor of current time divided by interval
      const windowIndex = Math.floor(now / intervalMs);
      const productIndex = windowIndex % products.length;

      if (productIndex === activeProductIndex) return;
      activeProductIndex = productIndex;

      const product = products[productIndex];
      if (!product) return;

      // Update links
      if (productLinkEl) {
        productLinkEl.textContent = product.title;
        productLinkEl.setAttribute('href', product.url);
      }
      if (imgLinkEl) {
        imgLinkEl.setAttribute('href', product.url);
      }

      // Update image
      if (productImageEl) {
        productImageEl.setAttribute('src', product.image);
        productImageEl.setAttribute('alt', product.title);
      }

      // Show the original price as compare_at_price, and half price as current sale price
      const compareCents = Math.round(product.price / discountMultiplier); // Original price
      const currentCents = product.price; // 50% off price
      
      if (comparePriceEl) {
        comparePriceEl.textContent = formatMoney(compareCents);
      }
      if (currentPriceEl) {
        currentPriceEl.textContent = formatMoney(currentCents);
      }
      if (discountBadgeEl) {
        discountBadgeEl.textContent = `${discountPercentage}% OFF`;
      }

      // Update variant input
      if (variantInputEl) {
        variantInputEl.value = product.variant_id;
      }

      // Update stock indicator
      const qty = product.inventory_quantity || 100;
      let percent = Math.min(100, Math.max(10, qty * 2.5));
      if (stockFillEl) {
        stockFillEl.style.width = `${percent}%`;
        if (qty < 15) {
          stockFillEl.style.backgroundColor = '#9E3B2B'; // sale terracotta
        } else {
          stockFillEl.style.backgroundColor = '#C08A6B'; // rose copper
        }
      }
      if (stockTextEl) {
        if (qty < 15) {
          stockTextEl.textContent = `CRITICAL STOCK: ONLY ${qty} LEFT - SELLING FAST`;
        } else {
          stockTextEl.textContent = `IN STOCK - READY TO DROP`;
        }
      }
    }

    function updateCountdown() {
      const now = Date.now();
      const nextWindowTime = (Math.floor(now / intervalMs) + 1) * intervalMs;
      const distance = nextWindowTime - now;

      if (distance <= 0) {
        updateActiveProduct();
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    updateActiveProduct();
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  document.addEventListener('DOMContentLoaded', initFlashDealHero);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initFlashDealHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slideshow"] && !Shopify.designMode) return;
  try {
    
  function initTestimonialsSlideshows() {
    document.querySelectorAll('.testimonials__carousel').forEach(function (carousel) {
      if (carousel.dataset.sliderInitialized) return;
      carousel.dataset.sliderInitialized = 'true';

      var slides = Array.from(carousel.querySelectorAll('.testimonials__slide'));
      var dots = Array.from(carousel.querySelectorAll('.testimonials__dot'));
      var prevBtn = carousel.querySelector('.testimonials__arrow--prev');
      var nextBtn = carousel.querySelector('.testimonials__arrow--next');
      if (slides.length === 0) return;

      var currentIndex = 0;
      var autoplayTimer = null;
      var autoplay = carousel.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed, 10) || 6000;

      function showSlide(index) {
        currentIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === currentIndex);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
          dot.setAttribute('aria-selected', i === currentIndex ? 'true' : 'false');
        });
      }

      function startAutoplay() {
        if (!autoplay || slides.length < 2) return;
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          showSlide(currentIndex + 1);
        }, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          showSlide(currentIndex - 1);
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          showSlide(currentIndex + 1);
          startAutoplay();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showSlide(parseInt(dot.dataset.index, 10));
          startAutoplay();
        });
      });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);

      showSlide(0);
      startAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', initTestimonialsSlideshows);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTestimonialsSlideshows);
  }

  } catch(e) { console.error(e); }
})();
})();
